import { gql } from '@apollo/client'

const DELETE_NOT_EXPORTED_UNKNOWN_WORD_MUTATION = gql`
  mutation deleteNotExportedUnknownWordMutation($id: ID!) {
    deleteNotExportedUnknownWord(id: $id)
  }
`

export default DELETE_NOT_EXPORTED_UNKNOWN_WORD_MUTATION
